import { supabase } from '../supabaseClient';
import { todayKstIso } from './formatLastAccess';

const REPORTED_KEY_PREFIX = 'cp.auth.lastActiveReportedOn.v1:';
const CHECK_INTERVAL_MS = 30 * 60 * 1000;

function readReportedOn(userId: string): string | null {
  try {
    return window.localStorage.getItem(REPORTED_KEY_PREFIX + userId);
  } catch {
    return null;
  }
}

function writeReportedOn(userId: string, iso: string): void {
  try {
    window.localStorage.setItem(REPORTED_KEY_PREFIX + userId, iso);
  } catch {
    /* quota */
  }
}

let inFlight: Promise<void> | null = null;

/** 오늘 아직 서버에 기록하지 않았으면 마지막 이용일을 1회 갱신 (같은 날은 LS 비교만) */
export function reportUserLastActiveIfNewDay(userId: string): Promise<void> {
  const uid = userId.trim();
  if (!uid || typeof window === 'undefined') return Promise.resolve();
  const today = todayKstIso();
  if (readReportedOn(uid) === today) return Promise.resolve();
  if (inFlight) return inFlight;
  inFlight = (async () => {
    try {
      const { error } = await supabase.rpc('touch_my_last_active');
      if (!error) writeReportedOn(uid, today);
    } catch {
      /* 네트워크 실패 시 다음 확인 때 재시도 */
    } finally {
      inFlight = null;
    }
  })();
  return inFlight;
}

/** 로그인 동안 탭 복귀·주기 확인으로 날짜 변경을 감지 */
export function startUserLastActiveDailyWatch(userId: string): () => void {
  const check = () => {
    if (document.visibilityState !== 'visible') return;
    void reportUserLastActiveIfNewDay(userId);
  };
  check();
  const timer = window.setInterval(check, CHECK_INTERVAL_MS);
  document.addEventListener('visibilitychange', check);
  return () => {
    window.clearInterval(timer);
    document.removeEventListener('visibilitychange', check);
  };
}
